import { of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { AlertService } from '../alert/alert.service';

@Injectable()
export class AppCacheResolver {
	constructor(private cacheService: CacheService, private alertService: AlertService) {
	}

	resolve() {
		return this.cacheService.lister().pipe(
			catchError(error => {
				this.alertService.error(error.error);
				return observableOf(null);
			}));
	}
}
